<template>
  <div class="my-8">
    <button
      class="w-full flex justify-between p-5 bg-grey-10 dark:bg-dark-bg"
      :class="{ 'rounded-t-lg': isOpen, 'rounded-lg': !isOpen }"
      type="button"
      :aria-expanded="isOpen"
      @click="toggle"
    >
      <div class="flex-1 flex items-center">
        <div v-if="icon" class="bg-pink-1 rounded-full p-2 mr-3">
          <mdicon
            :name="icon"
            :aria-label="icon"
            class="text-white"
            :size="20"
          />
        </div>
        <p>
          <slot name="title">{{ title }}</slot>
        </p>
      </div>
      <mdicon
        :name="isOpen ? 'chevron-up' : 'chevron-down'"
        aria-hidden="true"
        :size="20"
      />
    </button>
    <div
      ref="content"
      class="bg-grey-10 dark:bg-dark-bg overflow-hidden transition-all duration-300 ease-in-out rounded-b-lg"
      :style="{ maxHeight: isOpen ? contentHeight + 'px' : '0' }"
    >
      <div class="p-6">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'toggle'])

const isOpen = ref(props.modelValue)
const content = ref(null)
const contentHeight = ref(0)

const updateContentHeight = () => {
  if (content.value) {
    contentHeight.value = content.value.scrollHeight
  }
}

onMounted(() => {
  nextTick(() => {
    updateContentHeight()
    if (!isOpen.value) {
      contentHeight.value = 0
    }
  })
})

watch(
  () => props.modelValue,
  (newValue) => {
    isOpen.value = newValue
    nextTick(updateContentHeight)
  }
)

const toggle = () => {
  isOpen.value = !isOpen.value
  nextTick(updateContentHeight)
  emit('update:modelValue', isOpen.value)
  emit('toggle', isOpen.value)
}

const resizeObserver = new ResizeObserver(() => {
  updateContentHeight()
})

onMounted(() => {
  if (content.value) {
    resizeObserver.observe(content.value)
  }
})
</script>
